const privacyAR = {
  seo: {
    title: "سياسة الخصوصية | QuadroCode",
    description:
      "اطلع على سياسة الخصوصية الخاصة بـ QuadroCode لمعرفة البيانات التي نجمعها وكيف نستخدمها وكيفية التواصل معنا.",
  },
  hero: {
    eyebrow: "الخصوصية ومعالجة البيانات",
    title: "سياسة الخصوصية",
    intro:
      "توضح هذه الصفحة كيف تقوم QuadroCode بجمع المعلومات واستخدامها ومشاركتها وحمايتها عند زيارة موقع www.quadrocode.com.",
    effectiveDateLabel: "تاريخ السريان",
    updatedLabel: "آخر تحديث",
    effectiveDate: "1 مارس 2026",
    updatedDate: "1 مارس 2026",
    websiteLabel: "الموقع",
    websiteValue: "www.quadrocode.com",
    contactLabel: "التواصل بخصوص الخصوصية",
    contactValue: "info@quadrocode.com",
  },
  jumpLabel: "الانتقال إلى القسم",
  quickFacts: [
    {
      icon: "shield",
      title: "عدم بيع البيانات الشخصية",
      text: "نحن لا نقوم ببيع بياناتكم الشخصية.",
    },
    {
      icon: "cookie",
      title: "استخدام ملفات تعريف الارتباط",
      text: "قد نستخدم ملفات تعريف الارتباط وأدوات التحليل لفهم الزيارات والتفضيلات.",
    },
    {
      icon: "rights",
      title: "حقوقكم",
      text: "يمكنكم طلب الوصول إلى البيانات أو تعديلها أو حذفها أو سحب الموافقة حيثما ينطبق ذلك.",
    },
  ],
  sections: [
    {
      id: "introduction",
      number: "01",
      title: "المقدمة",
      icon: "document",
      paragraphs: [
        'مرحبًا بكم في QuadroCode ("الشركة"، "نحن"). توضح هذه السياسة كيفية جمع واستخدام والإفصاح عن وحماية معلوماتكم عند زيارة موقع www.quadrocode.com.',
        "باستخدامكم للموقع، فإنكم توافقون على هذه السياسة. وإذا كنتم لا توافقون على شروطها، يرجى عدم استخدام الموقع.",
      ],
    },
    {
      id: "information-we-collect",
      number: "02",
      title: "المعلومات التي نجمعها",
      icon: "globe",
      subsections: [
        {
          title: "المعلومات الشخصية",
          items: [
            "الاسم الكامل",
            "البريد الإلكتروني",
            "رقم الهاتف",
            "اسم الشركة",
            "تفاصيل المشروع المرسلة عبر النماذج",
            "أي معلومات تقدمونها طوعًا",
          ],
        },
        {
          title: "المعلومات التي يتم جمعها تلقائيًا",
          items: [
            "عنوان IP",
            "نوع المتصفح",
            "معلومات الجهاز",
            "الصفحات التي تمت زيارتها",
            "مدة التصفح",
            "مصادر الإحالة",
          ],
          note: "يتم جمع هذه البيانات عبر ملفات تعريف الارتباط وأدوات التحليل.",
        },
      ],
    },
    {
      id: "how-we-use-information",
      number: "03",
      title: "كيفية استخدام المعلومات",
      icon: "usage",
      items: [
        "الرد على الاستفسارات",
        "تقديم عروض المشاريع والاستشارات",
        "تحسين خدماتنا",
        "تحليل أداء الموقع",
        "إرسال التحديثات أو العروض عند وجود موافقة",
        "ضمان أمان الموقع",
      ],
    },
    {
      id: "cookies",
      number: "04",
      title: "ملفات تعريف الارتباط وتقنيات التتبع",
      icon: "cookie",
      paragraphs: ["نستخدم ملفات تعريف الارتباط والتقنيات المشابهة من أجل:"],
      items: ["تحسين تجربة المستخدم", "تحليل الزيارات", "تذكر التفضيلات"],
      note: "يمكنكم تعطيل ملفات تعريف الارتباط من إعدادات المتصفح.",
    },
    {
      id: "sharing",
      number: "05",
      title: "مشاركة المعلومات",
      icon: "lock",
      paragraphs: ["نحن لا نقوم ببيع بياناتكم الشخصية."],
      preface: "قد تتم مشاركة البيانات مع:",
      items: [
        "مزودي الاستضافة",
        "مزودي التحليلات مثل Google Analytics",
        "معالجي الدفع عند الحاجة",
        "الجهات القانونية إذا تطلب القانون ذلك",
      ],
    },
    {
      id: "retention",
      number: "06",
      title: "الاحتفاظ بالبيانات",
      icon: "shield",
      paragraphs: ["نحتفظ بالبيانات الشخصية فقط للمدة اللازمة من أجل:"],
      items: ["الأغراض التجارية", "الامتثال القانوني", "الالتزامات التعاقدية"],
    },
    {
      id: "security",
      number: "07",
      title: "حماية البيانات",
      icon: "lock",
      paragraphs: [
        "نتخذ إجراءات تقنية وتنظيمية لحماية بياناتكم، ولكن لا توجد وسيلة نقل عبر الإنترنت آمنة بنسبة 100٪.",
      ],
    },
    {
      id: "rights",
      number: "08",
      title: "حقوقكم",
      icon: "rights",
      paragraphs: ["بحسب الجهة القضائية التي تنطبق عليكم، قد يكون لكم الحق في:"],
      items: [
        "الوصول إلى بياناتكم",
        "طلب تصحيحها",
        "طلب حذفها",
        "سحب الموافقة",
        "الاعتراض على المعالجة",
      ],
      note: "لممارسة حقوقكم، يرجى التواصل معنا عبر info@quadrocode.com.",
    },
    {
      id: "third-party-links",
      number: "09",
      title: "روابط الجهات الخارجية",
      icon: "globe",
      paragraphs: [
        "قد يحتوي موقعنا على روابط لمواقع خارجية. نحن غير مسؤولين عن ممارسات الخصوصية الخاصة بها.",
      ],
    },
    {
      id: "changes",
      number: "10",
      title: "التعديلات على هذه السياسة",
      icon: "document",
      paragraphs: ["قد نقوم بتحديث هذه السياسة بشكل دوري، وسيتم نشر أي تغييرات على هذه الصفحة."],
    },
    {
      id: "contact-information",
      number: "11",
      title: "معلومات التواصل",
      icon: "mail",
      contactCard: {
        company: "Quadrocode LTD",
        addressLines: ["UK, Suite 402, Level 4, Newford", "UK"],
        email: "info@quadrocode.com",
      },
    },
  ],
  backHome: "العودة إلى الرئيسية",
};

export default privacyAR;
